import {KeyValuePair} from './structured-content-models';

export class FieldConfiguration {
  value = '';
  options: Array<KeyValuePair> = new Array<KeyValuePair>();
  defaultOptionKey = '';
  visible = true;
}
